import ButtonWithIcon from "../../components/ButtonWithIcon/ButtonWithIcon";
import HeadPage from "../../components/HeadPage/HeadPage";
import RoundGrid from "../../components/RoundGrid/RoundGrid";
import TopicsPreview from "../../components/TopicsPreview/TopicsPreview";
import VisitUsContent from "../../components/VisitUsContent/VisitUsContent";
import { fetchData } from "../../fetcher";
import TheMallOutletLayout from "../../layouts/TheMallOutletLayout/TheMallOutletLayout";
import styles from "../../styles/pages/visit-us.module.scss";
import Download from "../../public/assets/icons/downloadGold.svg";
import ScrollDown from "../../components/ScrollDown/ScrollDown";
import React, { useState, useRef, useEffect } from "react";
import CardCarousel from "../../components/CardCarousel/CardCarousel";
import axios from "axios";
import WrapperDetail from "../../components/WrapperDetail/WrapperDetail";
import surroundingStyles from "../../styles/pages/surroundings.module.scss";
import Related from "../../components/Related/Related";



const VisitUsPage = ({ menuItems, dataContent }) => {
  const scrollToRef = useRef(null);
  const ids = {
    contact: "contact",
    howto: "howto",
    services: "services",
    booking: 'booking',
    downloads: "downloads",
  };
  const [parent, setParent] = useState();
  const useIsomorphicLayoutEffect =
    typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
  useIsomorphicLayoutEffect(() => {
    document.querySelector('[class^=RoundGrid_title__]').style.display = 'none';

    return () => {
      document.querySelector('[class^=RoundGrid_title__]').style.display = 'none';
    }
    setParent(scrollToRef.current);
  }, [scrollToRef.current])

  useEffect(() => {
   
  }, [])

  console.log('DATA', dataContent)

  return (
    <TheMallOutletLayout menuItems={menuItems}>
      <div id="head">
        <HeadPage {...dataContent?.head} scrollToRef={scrollToRef} />
      </div>

      <div className={surroundingStyles.surroundingsIntro} ref={scrollToRef}>
        <div className={surroundingStyles.surroundingsTitle}>
          {dataContent?.desctitle}
        </div>

        <div className={`centeredSection ${styles.WrapperDetail} ${surroundingStyles.surroundingsDesc}`} dangerouslySetInnerHTML={{
              __html: dataContent?.description.replace(/ /g, ' '),
            }}>
        </div>
      </div>

      <div
        className={`smallerCenteredSection ${styles.visitUsContent}`}
        
      >

        <div id={ids.services} className={"anchor_section " + styles.roundGrid}>
          <RoundGrid {...dataContent?.roundGrid} />
        </div>
        
        {dataContent.downloads && <div
          className={"anchor_section " + styles.downloads}
        >
          <div className={styles.title}>{dataContent.downloads.title}</div>
          {dataContent.downloads.image && <div style={{textAlign: 'center'}}><img src={dataContent.downloads.image} 
            style={{width: '190px', height: '190px', borderRadius: '1000px'}}>
          </img></div>}
          <div className={styles.content} style={{margin: '20px 0'}}>{dataContent.downloads.subtitle}</div>
          <div className={styles.button}>
            <ButtonWithIcon
              link={dataContent.downloads.link}
              
              outline={true}
            // lightGold
            />
          </div>
        </div>}
        
        <Related related={dataContent.related} margin="0" />
        
        {scrollToRef && (
          <div
            className="scroll"
          >
            <ScrollDown selector={scrollToRef} scrollTop />
          </div>
        )}
      </div>
    </TheMallOutletLayout>
  );
};

VisitUsPage.getInitialProps = async (context) => {
  let menuItems = null;
  let dataContent = null;
  const { slug } = context.query;

  const resmenu = await fetchData("/init", context.query.locale);
  const data = await fetchData(slug, context.query.locale);

  console.log(slug, resmenu, data)

  if (resmenu) {
    menuItems = resmenu.menu;
  }

  if (data) {
    dataContent = data;
  }

  return {
    menuItems: menuItems,
    dataContent: dataContent,
  };
};

export default VisitUsPage;
